/** Scene metadata `playerWarmup` — when leftover finishes start loading after first paint. */

export type PlayerWarmupMode = 'off' | 'late' | 'balanced' | 'eager';

export const PLAYER_WARMUP_OPTIONS: { id: PlayerWarmupMode; label: string; hint: string }[] = [
  { id: 'eager', label: 'Eager', hint: 'Start right after reveal — fastest first material click' },
  { id: 'balanced', label: 'Balanced', hint: 'Short pause so the first frames stay smooth' },
  { id: 'late', label: 'Late', hint: 'Wait ~1–3s so first paint is not competing' },
  { id: 'off', label: 'Off', hint: 'Only load a finish when it is selected' },
];

/** Delays in ms after the player first reveals. `off` is handled by skipping warmup. */
export const PLAYER_WARMUP_DELAYS: Record<Exclude<PlayerWarmupMode, 'off'>, { glb: number; tex: number; eval: number }> = {
  eager: { glb: 0, tex: 0, eval: 250 },
  balanced: { glb: 150, tex: 400, eval: 1000 },
  late: { glb: 600, tex: 1400, eval: 2800 },
};

export function parsePlayerWarmupMode(value: unknown): PlayerWarmupMode {
  if (value === 'off' || value === 'late' || value === 'balanced' || value === 'eager') return value;
  // Unset scenes: try eager (first-click finishes) until the scene setting is saved.
  return 'eager';
}
